import { Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import ReactComponent from '@/components/ReactComponent';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

class QuantidadePartesAutoras extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            qtdPartesAutoras: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get qtdPartesAutoras() {
        if (
            this.registro?.detalhes?.quantidadePartesAutoras &&
            Number.isFinite(this.registro.detalhes.quantidadePartesAutoras)
        ) {
            return Number.parseInt(this.registro.detalhes.quantidadePartesAutoras);
        }

        return 0;
    }

    render() {
        const fontSize = this.props.fontSize || '0.9rem';

        return (
            <Typography
                sx={{
                    fontWeight: 'bold',
                    fontSize: fontSize,
                    lineHeight: fontSize,
                    mr: 2,
                    color: this.qtdPartesAutoras !== 1 ? red[900] : '#01579b'
                }}
            >
                <Typography
                    component="span"
                    sx={{
                        fontSize: '1.3rem',
                        lineHeight: '1.3rem',
                        fontWeight: 'bold'
                    }}
                >
                    {this.qtdPartesAutoras}
                </Typography>{' '}
                {this.qtdPartesAutoras > 1 ? 'partes autoras' : 'parte autora'}
            </Typography>
        );
    }
}

export default inject('stores')(observer(QuantidadePartesAutoras));
